import { CrossFrameUtils } from '@amzn/jwo-store-management-platform-components'
import { store } from '@atredux/store'
import { getSelectedLocale } from '@src/redux/selectors/localeSelector'
import { getToolUrl } from '@src/services/ToolMenuConfigService'

const SITEASSIST_TOOL_NAME: string = 'Site Assist'
const SITEASSIST_TOOL_ID: string = 'grocery_site_assistant_tool'

export const SAFrameId = 'SAFrame'

export class SiteAssistModalUtils {
    private static siteAssistBaseUrl: string
    private static siteAssistParams: string

    public static getUrl () {
        if (!this.siteAssistBaseUrl) {
            const url = getToolUrl(SITEASSIST_TOOL_NAME, SITEASSIST_TOOL_ID)
            this.siteAssistBaseUrl = url?.split('?')[0]
            this.siteAssistParams = url?.split('?')[1]
        } else {
            const localeParam = store?.getState().locale ? getSelectedLocale(store.getState()) : 'en-US'
            const queryParams = new URLSearchParams(this.siteAssistParams)
            queryParams.set('locale', localeParam)
            this.siteAssistParams = queryParams.toString()
        }

        if (!this.siteAssistBaseUrl) {
            return ''
        }
        return this.siteAssistBaseUrl + '?' + this.siteAssistParams
    }

    public static async sendSAEvent (event: string, data: string) {
        const contentWindow = (document.getElementById(SAFrameId) as HTMLIFrameElement).contentWindow
        return CrossFrameUtils.sendMessageToOtherFrame({
            frame: contentWindow,
            message : {
                method: event,
                data,
            },
        })
    }
}
